import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getAppName, getLogo } from '../../../../utils/get-logo';

export const Overview = () => {
  const { t } = useTranslation('chat2');
  return (
    <motion.div
      key="overview"
      className="max-w-3xl mx-auto md:mt-20 flex flex-col items-center justify-center"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.98 }}
      transition={{ delay: 0.5 }}
    >
      <div className="rounded-xl p-6 flex flex-col gap-8 leading-relaxed text-center max-w-xl">
        <p className="flex flex-row justify-center gap-4 items-center">
          <img
            src={getLogo()}
            alt={t('overview.logoAlt', { appName: getAppName() })}
            className="w-12 h-12 dark:border dark:border-border/20 dark:rounded-full"
          />
        </p>
        <p>{t('overview.description')}</p>
      </div>
    </motion.div>
  );
};
